// File: src/api/wallet/phoneVerify.tsx

import { auth } from "../../firebaseConfig";
import { apiBase } from "../../firebaseConfig"; // same as in updatePreferences

/**
 * Internal helper to call the backend with the Firebase ID-token header.
 */
async function request<T>(
  path: string,
  body: Record<string, unknown>
): Promise<T> {
  const idToken = await auth.currentUser?.getIdToken();
  if (!idToken) throw new Error("Not authenticated");

  const res = await fetch(`${apiBase()}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  return res.json() as Promise<T>;
}

/** Kick off SMS via /verify/sendCode */
export function sendCode(phone: string) {
  return request<{ status: string }>("/verify/sendCode", { phone });
}

/** Confirm OTP via /verify/checkCode */
export function checkCode(phone: string, code: string) {
  return request<{ success: boolean }>("/verify/checkCode", { phone, code });
}
